import ko from '@tko/build.knockout';
import _ from 'lodash';
import templateMarkup from 'raw-loader!./share-panel-modal.html';
import '../../app/bindings/ko-bindinghandler-tokenfield';
import PreferenceService from "../../services/preference.service";
import Selectr from 'mobius1-selectr/src/selectr';
import DashboardService from '../../modules/assurance/services/dashboard.service';
import DashboardDataService from '../dragdrop-grid/data/dashboard.service';
import PanelOptionsService from '../../modules/assurance/dialogs/panel-options/panel-options.service';

function SharePanel(params) {
  let self = this;


  const HISTORICAL2_PANEL_TYPES = {
    DISTRIBUTION: 'Distribution',
    KPI: 'KPIPanel',
    SUMMARY: 'SummaryPanel',
    TREND: 'Trend'
  };

  self.signals = ko.unwrap(params.signals);

  if (!_.has(self, 'signals.onShow') || !_.has(self, 'signals.onSave')) {
    throw new Error('SharePanel:: Missing required signals: show, save');
  }

  self.signals.onShow.add(_.bind(self.show, self));
  self.signals.onSave.add(_.bind(self.save, self));

  self.updateError = ko.observable();
  self.hasUpdateError = ko.pureComputed(function () {
    return !_.isEmpty(self.updateError());
  });

  self.panelsMap = {};
  self.showAppSelectr = ko.observable(true); // IMPORTANT! this needs to default to true for Selectr to initialize properly

  self.fromUserSelctr = new Selectr('#panel-fromUserSelector', {
    defaultSelected: false,
    placeholder: 'Select a User...'
  } );

  self.fromAppSelctr = new Selectr('#panel-fromAppSelector', {
    allowDeselect: true,
    clearable: true,
    defaultSelected: false,
    placeholder: 'Select an App and View...'
  });

  self.fromDashboardSelctr = new Selectr('#panel-fromDashboardSelector', {
    defaultSelected: false,
    placeholder: 'Select Dashboards...'
  } );

  self.toUserSelctr = new Selectr('#panel-toUserSelector', {
    defaultSelected: false,
    placeholder: 'Select a User...'
  } );

  self.toAppSelctr = new Selectr('#panel-toAppSelector', {
    allowDeselect: true,
    clearable: true,
    defaultSelected: false,
    placeholder: 'Select an App and View...'
  });

  self.toDashboardSelctr = new Selectr('#panel-toDashboardSelector', {
    defaultSelected: false,
    placeholder: 'Select Dashboards...'
  });

  self.panelSelctr = new Selectr('#panel-panelSelector', {
    defaultSelected: false,
    placeholder: 'Select Panels...'
  });

  self.fromUserSelctr.on('selectr.select', function(option) {
    self.fromAppSelctr.clear();
    self.fromAppSelctr.reset(); // technically I don't need to do this, but it make loading easier
    self.updateError('');
  });

  let loadFromUserTabs = function(option) {
    let appView = self.showAppSelectr() ? self.fromAppSelctr.getValue() : self.appViewData[0].value;
    self.fromDashboardSelctr.clear();
    self.fromDashboardSelctr.removeAll();
    self.updateError('');
    if (appView) {
      let appViewArray = appView.split('/');
      let userId = self.fromUserSelctr.getValue();
      if (userId) {
        PreferenceService.getTabs(appViewArray[0], appViewArray[1], userId).then(tabList => {
          _.forEach(tabList, tab => {
            self.fromDashboardSelctr.add({value: tab.id, text: tab.name})
          })
        });
      }
    }
  };
  let loadToUserTabs = function(option) {
    let appView = self.showAppSelectr() ? self.toAppSelctr.getValue() : self.appViewData[0].value;
    self.toDashboardSelctr.clear();
    self.toDashboardSelctr.removeAll();
    self.updateError('');
    if (appView) {
      let appViewArray = appView.split('/');
      let userId = self.toUserSelctr.getValue();
      if (userId) {
        PreferenceService.getTabs(appViewArray[0], appViewArray[1], userId).then(tabList => {
          _.forEach(tabList, tab => {
            self.toDashboardSelctr.add({ value: tab.id, text: tab.name })
          })
        });
      }
    }
  };
  let loadPanels = function() {
    let appView = self.showAppSelectr() ? self.fromAppSelctr.getValue() : self.appViewData[0].value;
    let userId = self.fromUserSelctr.getValue();
    self.panelSelctr.clear();
    self.panelSelctr.removeAll();
    self.panelsMap = {};
    self.updateError('');
    if (appView) {
      let appViewArray = appView.split('/');
      let tabId = self.fromDashboardSelctr.getValue();
      if (tabId) {
        PreferenceService.getUserTabPanels(userId, appViewArray[0], appViewArray[1], tabId).then(panelList => {
          let datasetPanels = [];
          let kpiPanels = [];
          let trendPanels = [];
          let summaryPanels = [];
          let distributionPanels = [];
          _.forEach(panelList, panel => {
            let title = panel.params.options.title ?
                        panel.params.options.title : panel.params.options.panelHeader ?
                                                     panel.params.options.panelHeader : 'unnamed panel';
            let selectrData = { value: panel.id, text: title };
            self.panelsMap[panel.id] = panel;
            // assurance
            if (self.appId === 'assurance') {
              if (panel.type === PanelOptionsService.DATASET_TYPE.panelType) datasetPanels.push(selectrData);
              if (panel.type === PanelOptionsService.KPI_TYPE.panelType) kpiPanels.push(selectrData);
              if (panel.type === PanelOptionsService.TREND_TYPE.panelType) trendPanels.push(selectrData);
            } else {
              // historical2 / workspace insights
              if (panel.type === HISTORICAL2_PANEL_TYPES.DISTRIBUTION) distributionPanels.push(selectrData);
              if (panel.type === HISTORICAL2_PANEL_TYPES.KPI) kpiPanels.push(selectrData);
              if (panel.type === HISTORICAL2_PANEL_TYPES.SUMMARY) summaryPanels.push(selectrData);
              if (panel.type === HISTORICAL2_PANEL_TYPES.TREND) trendPanels.push(selectrData);
            }
          });

          let data = [];

          if (datasetPanels.length) {
            datasetPanels.sort(sortFunc);
            data.push({
              text: 'Dataset Panels',
              children: datasetPanels
            });
          }

          if (distributionPanels.length) {
            distributionPanels.sort(sortFunc);
            data.push({
              text: 'Distribution Panels',
              children: distributionPanels
            });
          }

          if (kpiPanels.length) {
            kpiPanels.sort(sortFunc);
            data.push({
              text: 'KPI Panels',
              children: kpiPanels
            });
          }

          if (summaryPanels.length) {
            summaryPanels.sort(sortFunc);
            data.push({
              text: 'Summary Panels',
              children: summaryPanels
            });
          }

          if (trendPanels.length) {
            trendPanels.sort(sortFunc);
            data.push({
              text: 'Trend Panels',
              children: trendPanels
            });
          }

          // we have to destroy and recreate the Selectr because the .add() function doesn't support "children"
          self.panelSelctr.destroy();
          self.panelSelctr = new Selectr('#panel-panelSelector', {
            defaultSelected: false,
            placeholder: 'Select Panels...',
            data: data
          });

          function sortFunc(a, b) {
            if (a.text.toLowerCase() < b.text.toLowerCase()) return -1;
            if (a.text.toLowerCase() > b.text.toLowerCase()) return 1;
            return 0;
          }
        });
      }
    }
  }

  self.fromAppSelctr.on('selectr.select', loadFromUserTabs);
  self.fromAppSelctr.on('selectr.deselect', loadFromUserTabs);
  self.toAppSelctr.on('selectr.select', loadToUserTabs);
  self.toAppSelctr.on('selectr.deselect', loadToUserTabs);

  self.fromUserSelctr.on('selectr.select', loadFromUserTabs);
  self.fromUserSelctr.on('selectr.deselect', loadFromUserTabs);
  self.toUserSelctr.on('selectr.select', loadToUserTabs);
  self.toUserSelctr.on('selectr.deselect', loadToUserTabs);

  self.fromDashboardSelctr.on('selectr.select', loadPanels);
  self.fromDashboardSelctr.on('selectr.deselect', loadPanels);

  self.toUserSelctr.on('selectr.change', function(option) {
    // TODO: anything else to do here?
    self.updateError('');
  });


  self.saveCallback = null;

}

SharePanel.prototype.show = function (model) {
  var self = this;

  if (!_.has(model, 'appId')) {
    throw new Error('SharePanel needs a model with an appId.');
  }
  if (!_.has(model, 'viewId')) {
    throw new Error('SharePanel needs a model with an viewId.');
  }

// not sure if I need any of these to pre-populate the advanced dialog entries
  self.appId = model.appId;
  // self.viewId = model.viewId;
  // self.currentBoard = model.currentBoard;
  // self.currentUserId = model.currentUserId;

  // TODO: Once other apps have multiple "dashboard" views, this modal should support them.
  //       Currently only historical2 has multiple dashboard views.
  self.showAppSelectr(self.appId === 'historical2');
  self.appViewData = [];
  if (self.appId === 'historical2') {
    self.appViewData = [{
        value: "historical2/historical2dashboard",
        text: "My Dashboards"
      },
      {
        value: "historical2/historical2adoption",
        text: "Adoption"
      },
      {
        value: "historical2/historical2issues",
        text: "Issues"
      },
      {
        value: "historical2/historical2capacity",
        text: "Capacity"
      },
      {
        value: "historical2/historical2roomboard",
        text: "Workspaces"
      }
    ];
  } else if (self.appId === 'rooms') {
    self.appViewData = [{
      value: "rooms/historical2roomboard",
      text: "My Dashboards"
    }];
  } else if (self.appId === 'assurance') {
    self.appViewData = [{
      value: "assurance/dashboard",
      text: "My Dashboards"
    }];
  } else {
    throw new Error('SharePanel:: Unknown appId: ' + self.appId);
  }

  self.saveCallback = model.saveCallback;
  self.updateError(null);

  // not super efficient resetting and reloading all data, but works for now
  self.fromUserSelctr.clear();
  self.fromUserSelctr.removeAll();

  self.fromAppSelctr.clear();
  self.fromAppSelctr.removeAll();
  self.fromAppSelctr.add(self.appViewData);

  self.fromDashboardSelctr.clear();
  self.fromDashboardSelctr.removeAll();

  self.toUserSelctr.clear();
  self.toUserSelctr.removeAll();

  self.toAppSelctr.clear();
  self.toAppSelctr.removeAll();
  self.toAppSelctr.add(self.appViewData);

  self.toDashboardSelctr.clear();
  self.toDashboardSelctr.removeAll();

  DashboardService.fetchUsersForCurrentOrgTemp().then(users => {
    _.forEach(users, user => {
      if (!user.deleted) {
        self.fromUserSelctr.add({value: user.id, text: user.name});
        self.toUserSelctr.add({value: user.id, text: user.name});
      }
    })
  });

};

SharePanel.prototype.save = function () {
  let self = this;
  let fromUserId = self.fromUserSelctr.getValue();
  let fromAppId = self.showAppSelectr() ? self.fromAppSelctr.getValue() : self.appViewData[0].value;
  let fromBoard = self.fromDashboardSelctr.getValue();
  let toUserId = +self.toUserSelctr.getValue(); // "+" to convert to number
  let toAppId = self.showAppSelectr() ? self.toAppSelctr.getValue() : self.appViewData[0].value;
  let toBoards = self.toDashboardSelctr.getValue();
  let panelIds = self.panelSelctr.getValue();
  let panels = [];

  if (fromUserId && fromAppId && fromBoard && toUserId && toAppId && toBoards && toBoards.length && panelIds && panelIds.length) {
    let toAppViewArray = self.showAppSelectr() ? self.toAppSelctr.getValue().split('/') : self.appViewData[0].value.split('/');
    let appId = toAppViewArray[0];
    let viewId = toAppViewArray[1];
    panels = panelIds.map(panelId => {
      let panel = self.panelsMap[panelId];
      let newPanel = {};
      if (self.appId === 'assurance') {
        let panelOptions = {
          panel: PanelOptionsService.getPanelOptions(panel.params.options),
          params: panel.params.options
        };
        newPanel = DashboardDataService.newPanel(panelOptions);
      } else {
        // historical2 / workspace insights
        newPanel = DashboardDataService.newPanel({
          panel: panel,
          params: panel.params.options
        });
      }
      delete newPanel.autoPosition;
      return newPanel;
    });

    try {
      _.forEach(toBoards, tabId => {
        PreferenceService.addOrUpdateUserPanels(toUserId, appId, viewId, tabId, panels);
      });
      self.updateError('');
    } catch(e) {
      console.error(e);
      self.updateError('There was an error sharing panels.');
    }
  } else {
    self.updateError('Please fill in all fields.')
  }

  if (!self.hasUpdateError()) {
    self.signals.closeModal.dispatch();
    if (self.saveCallback) self.saveCallback();
  }
};

SharePanel.prototype.dispose = function () {
  var self = this;
  self.signals.onShow.dispose();
  self.signals.onSave.dispose();
};

ko.components.register('share-panel-modal', { viewModel: SharePanel, template: templateMarkup });
